var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHappyTransitDweb = function SvgHappyTransitDweb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#46484D",
    d: "M8.66 0C3.883 0 0 3.552 0 7.917c0 4.79 6.02 10.237 7.868 11.793a1.23 1.23 0 0 0 1.584 0c1.846-1.557 7.867-7.005 7.867-11.793C17.319 3.552 13.434 0 8.659 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m5.943 5.963 1.806.748a.22.22 0 0 0 .18 0l1.916-.83a.116.116 0 0 0 0-.213L7.398 4.656a.43.43 0 0 0-.351 0l-1.104.462a.462.462 0 0 0 0 .85z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.025 5.839a1.14 1.14 0 0 0-.628-.624 1.13 1.13 0 0 0-.882 0l-6.12 2.66a.22.22 0 0 1-.193 0l-1.1-.554a.46.46 0 0 0-.387 0l-1.201.508a.462.462 0 0 0-.148.748l1.732 1.732a.46.46 0 0 0 .499.125L8.21 9.372a.12.12 0 0 1 .124.023.13.13 0 0 1 .028.124L7.44 11.93a.462.462 0 0 0 .642.573l1.252-.624a.46.46 0 0 0 .208-.207l1.732-3.464a.21.21 0 0 1 .124-.111l2.005-.748a1.155 1.155 0 0 0 .628-1.51h-.005z"
  })));
};
export default SvgHappyTransitDweb;